// @flow
import { hash } from "hash-it";

import type Href from "../../models/href/Href";
import type { SectionFragment } from "../../models";

/**
 * https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
const createHash = (str: string): number => {
  return hash(str);
};

/**
 */
const createHashFromHref = (href: Href, fragment?: SectionFragment): number => {
  const hrefString = href.hash
    ? [href.toString(), href.hash].join("#")
    : href.toString();

  if (fragment) {
    return hash({ hrefString, fragment });
  }

  return hash(hrefString);
};

export { createHash, createHashFromHref };
